<!-- Loading state -->
<div *ngIf="isLoading" style="padding: 40px; text-align: center; color: #6b7280;">
  Loading order details...
</div>

<div class="main-wrapper" *ngIf="!isLoading && order">
  <div class="page-wrapper">
    <div class="content">

      <div class="order-view-content">

        <div class="order-title-row">
          <div>
            <h4 class="order-title">{{ order.orderNo }} &mdash; {{ order.customerName }}</h4>
            <div class="order-subtitle">
              {{ order.route }}
              <span class="dot">&middot;</span>
              <span class="badge order-type-badge" [ngClass]="order.orderType?.toLowerCase()">
                {{ order.orderType | titlecase }}
              </span>
            </div>
          </div>

          <div class="title-actions">
            <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
            <a href="javascript:void(0)" class="back-link" (click)="goBack()">Back</a>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 1: General Details
        ══════════════════════════════════════ -->
        <div class="card-section">
          <div class="section-header">
            <span class="step-badge">1</span>
            <h5>General Details</h5>
          </div>

          <div class="section-body">
            <div class="form-grid">

              <div class="form-field">
                <label>Order No.</label>
                <input type="text" class="form-control" [value]="order.orderNo" readonly />
              </div>

              <div class="form-field">
                <label>LR Number</label>
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'editable': canEditLrNumber(), 'highlight-green': order.lrNumber }"
                  [readonly]="!canEditLrNumber()"
                  [(ngModel)]="order.lrNumber"
                  placeholder="--" />
              </div>

              <div class="form-field">
                <label>Customer</label>
                <input type="text" class="form-control" [value]="order.customerName" readonly />
              </div>

              <div class="form-field">
                <label>Order Type</label>
                <input type="text" class="form-control" [value]="order.orderType | titlecase" readonly />
              </div>

              <div class="form-field">
                <label>Vehicle Required At</label>
                <input type="text" class="form-control" [value]="order.vehicleRequiredAt" readonly />
              </div>

              <div class="form-field">
                <label>Status</label>
                <input type="text" class="form-control" [value]="statusLabel()" readonly />
              </div>

              <div class="form-field">
                <label>Bidding Status</label>
                <input type="text" class="form-control" [value]="order.biddingStatus || '--'" readonly />
              </div>

              <div class="form-field">
                <label>No. of Vehicles</label>
                <input type="text" class="form-control" [value]="order.numberOfVehicle" readonly />
              </div>

              <div class="form-field">
                <label>Assigned KAM</label>
                <input type="text" class="form-control" [value]="order.assignedKam" readonly />
              </div>

              <div class="form-field">
                <label>Assigned Proc. Exec.</label>
                <input
                  type="text"
                  class="form-control"
                  [ngClass]="{ 'editable': canEditProcExec() }"
                  [readonly]="!canEditProcExec()"
                  [(ngModel)]="order.assignedProcExec" />
              </div>

            </div>
          </div>

          <div class="section-footer" *ngIf="canEditGeneralDetails()">
            <button type="button" class="btn btn-purple" (click)="saveGeneralDetails()">Save</button>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 2: Order Points
        ══════════════════════════════════════ -->
        <div class="card-section" *ngIf="order.orderPoints && order.orderPoints.length">
          <div class="section-header">
            <span class="step-badge">2</span>
            <h5>Order Points</h5>
          </div>
          <div class="section-body">
            <div class="form-grid">
              <div class="form-field" *ngFor="let point of order.orderPoints">
                <label>{{ point.pointType }}</label>
                <input type="text" class="form-control"
                  [value]="point.address + (point.pincode ? ' - ' + point.pincode : '')" readonly />
              </div>
            </div>
          </div>
        </div>

        <!-- ══════════════════════════════════════
             SECTION 3: Pricing
        ══════════════════════════════════════ -->
        <div class="card-section" *ngIf="showPricingSection()">
          <div class="section-header" [ngClass]="{ 'between': showMarginBadge() }">
            <div class="d-flex align-items-center gap-2">
              <span class="step-badge">3</span>
              <h5>{{ pricingSectionTitle() }}</h5>
            </div>
            <span class="badge margin-badge" [ngClass]="marginBadgeClass()" *ngIf="showMarginBadge()">
              {{ marginPercent() }}% Margin
            </span>
          </div>

          <div class="section-body">

            <!-- Info banner -->
            <div class="info-banner" *ngIf="infoBannerText()">{{ infoBannerText() }}</div>

            <!-- Head approval pending banner -->
            <div class="approval-banner" *ngIf="showApprovalRequiredBanner()">
              <b>Approval Required.</b> KAM submitted a rate below adjusted procurement rate. Please review and enter approved amount.
            </div>

            <!-- HEAD_APPROVED banner for KAM -->
            <div class="approval-banner approval-banner-green"
              *ngIf="role === 'ROLE_KAM' && order.status === 'HEAD_APPROVED'">
              <b>Head Approved.</b> Approved Amount: <b>{{ formatCurrency(order.procHeadAmount) }}</b>. Please confirm or reject.
            </div>

            <!-- ═══ ROLE_KAM VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_KAM'">

              <!-- Contract -->
              <ng-container *ngIf="isContract()">
                <div class="contract-banner">
                  <b>Contract Order.</b>&nbsp; Rate: <b>{{ formatCurrency(order.confirmedAmount) }}</b>
                </div>
              </ng-container>

              <!-- Contract — KAM confirm/reject -->
              <ng-container *ngIf="isContract()">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Amount (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control" [value]="statusLabel()" readonly />
                  </div>
                </div>

                <!-- HEAD_APPROVED — KAM confirm or reject -->
                <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Head Approved Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                    </div>
                  </div>
                  <div class="approval-banner approval-banner-green" style="margin-top: 12px;">
                    <b>Head Approved.</b> Amount: <b>{{ formatCurrency(order.procHeadAmount) }}</b>. Please confirm or reject.
                  </div>
                  <div class="section-footer no-border">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                    <button type="button" class="btn btn-green" [disabled]="actionLoading" (click)="confirmOrder()">
                      {{ actionLoading ? 'Confirming...' : '✓ Confirm Order' }}
                    </button>
                  </div>
                </ng-container>

                <!-- ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status === 'ORDER_CONFIRMED'">
                  <div class="info-banner" style="margin-top: 12px;">
                    ✓ Order confirmed. Final Amount: <b>{{ formatCurrency(order.confirmedAmount) }}</b>
                  </div>
                </ng-container>

                <!-- QUOTE_SHARED or any other status — KAM can enter counter rate -->
                <ng-container *ngIf="order.status !== 'ORDER_CONFIRMED' && order.status !== 'HEAD_APPROVED' && order.status !== 'REJECTED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final BD Rate (₹) <span class="required">*</span></label>
                      <input
                        type="number"
                        class="form-control editable"
                        placeholder="Enter final rate"
                        [(ngModel)]="finalBdRateInput" />
                      <small class="field-hint" *ngIf="finalBdRateInput && order.procurementProvidedAmount">
                        <span *ngIf="finalBdRateInput < order.procurementProvidedAmount" class="hint-warn">
                          ⚠ Less than procurement rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.procurementProvidedAmount" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>
                  <div class="section-footer no-border">
                    <button type="button" class="btn btn-outline-red" [disabled]="actionLoading" (click)="rejectOrder()">Reject</button>
                    <button type="button" class="btn btn-purple" [disabled]="actionLoading || !finalBdRateInput" (click)="submitFinalBdRate()">
                      {{ actionLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </ng-container>

              </ng-container>

              <!-- Spot — Rate Known -->
              <ng-container *ngIf="isSpot() && !order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Rate (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Price Status</label>
                    <input type="text" class="form-control highlight-green" [value]="statusLabel()" readonly />
                  </div>
                </div>
              </ng-container>

              <!-- Spot — NULL Price — enter Final BD Rate -->
              <ng-container *ngIf="isSpot() && order.isNullPrice">
                <div class="form-grid">
                  <!-- <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                  </div> -->
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Confirmed Amount (₹)</label>
                    <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                  </div>
                </div>

                <!-- KAM enters Final BD Rate — only when NOT yet HEAD_APPROVED or ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status !== 'ORDER_CONFIRMED' && order.status !== 'HEAD_APPROVED' && order.status !== 'REJECTED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final BD Rate (₹) <span class="required">*</span></label>
                      <input
                        type="number"
                        class="form-control editable"
                        placeholder="Enter final BD rate"
                        [(ngModel)]="finalBdRateInput" />
                      <small class="field-hint" *ngIf="finalBdRateInput && order.adjustedProcRate">
                        <span *ngIf="finalBdRateInput < order.adjustedProcRate" class="hint-warn">
                          ⚠ Less than adjusted rate — will go to Head for approval
                        </span>
                        <span *ngIf="finalBdRateInput >= order.adjustedProcRate" class="hint-ok">
                          ✓ Will be confirmed directly
                        </span>
                      </small>
                    </div>
                  </div>

                  <div class="section-footer no-border">
                    <button
                      type="button"
                      class="btn btn-outline-red"
                      [disabled]="actionLoading"
                      (click)="rejectOrder()">
                      Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-purple"
                      [disabled]="actionLoading || !finalBdRateInput"
                      (click)="submitFinalBdRate()">
                      {{ actionLoading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </ng-container>

                <!-- KAM sees HEAD_APPROVED — Confirm or Reject -->
                <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Head Approved Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.procHeadAmount)" readonly />
                    </div>
                  </div>

                  <div class="section-footer no-border">
                    <button
                      type="button"
                      class="btn btn-outline-red"
                      [disabled]="actionLoading"
                      (click)="rejectOrder()">
                      Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-green"
                      [disabled]="actionLoading"
                      (click)="confirmOrder()">
                      {{ actionLoading ? 'Confirming...' : '✓ Confirm Order' }}
                    </button>
                  </div>
                </ng-container>

                <!-- ORDER_CONFIRMED -->
                <ng-container *ngIf="order.status === 'ORDER_CONFIRMED'">
                  <div class="form-grid mt-3">
                    <div class="form-field">
                      <label>Final Confirmed Amount (₹)</label>
                      <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                    </div>
                  </div>
                </ng-container>

              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_PROCUREMENT VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_PROCUREMENT'">

              <ng-container *ngIf="isContract()">
                <div class="contract-banner">
                  <b>Contract Order.</b>&nbsp; Rate: <b>{{ formatCurrency(order.confirmedAmount) }}</b>
                </div>
              </ng-container>

              <ng-container *ngIf="isSpot() && !order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Customer Rate (₹)</label>
                    <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [(ngModel)]="order.procurementRate" placeholder="Enter procurement rate" />
                  </div>
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control highlight-green" [value]="statusLabel()" readonly />
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="isSpot() && order.isNullPrice">
                <div class="form-grid">
                  <div class="form-field">
                    <label>Procurement Rate (₹)</label>
                    <input type="text" class="form-control" [(ngModel)]="order.procurementRate" placeholder="Enter procurement rate" />
                  </div>
                  <div class="form-field">
                    <label>Adjusted (KAM sees, +5%)</label>
                    <input type="text" class="form-control highlight-purple" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                  </div>
                  <div class="form-field">
                    <label>Status</label>
                    <input type="text" class="form-control" [value]="statusLabel()" readonly />
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_PROCUREMENT_HEAD VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_PROCUREMENT_HEAD'">

              <!-- Full pricing visibility -->
              <div class="form-grid">

                <div class="form-field">
                  <label>Customer Amount (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.customerAmount)" readonly />
                </div>

                <!-- <div class="form-field" *ngIf="isContract()">
                  <label>Contract Confirmed Amount (₹)</label>
                  <input type="text" class="form-control highlight-green" [value]="formatCurrency(order.confirmedAmount)" readonly />
                </div>
                 -->
                <div class="form-field">
                  <label>Procurement Rate (₹)</label>
                  <input type="text" class="form-control" [value]="formatCurrency(order.procurementProvidedAmount)" readonly />
                </div>

                <div class="form-field">
                  <label>Adjusted Proc. Rate (₹)</label>
                  <input type="text" class="form-control highlight-purple" [value]="formatCurrency(order.adjustedProcRate)" readonly />
                </div>

                <!-- <div class="form-field">
                  <label>Confirmed Amount (₹)</label>
                  <input type="text" class="form-control" [value]="formatCurrency(order.confirmedAmount)" readonly />
                </div> -->

                <div class="form-field" *ngIf="order.procHeadAmount">
                  <label>Head Amount (₹)</label>
                  <input type="text" class="form-control highlight-yellow" [value]="formatCurrency(order.procHeadAmount)" readonly />
                </div>

                <div class="form-field">
                  <label>Status</label>
                  <input type="text" class="form-control" [value]="statusLabel()" readonly />
                </div>

              </div>

              <!-- HEAD enters approved amount — only when HEAD_PENDING -->
              <ng-container *ngIf="order.status === 'HEAD_PENDING'">
                <div class="form-grid mt-3">
                  <div class="form-field">
                    <label>Head Approved Amount (₹) <span class="required">*</span></label>
                    <input
                      type="number"
                      class="form-control editable"
                      placeholder="Enter approved amount"
                      [(ngModel)]="procHeadAmountInput" />
                  </div>

                  <div class="form-field">
                    <label>Select Vendor <span class="required">*</span></label>
                    <ng-select
                      [items]="vendorList"
                      bindLabel="vendorName"
                      bindValue="id"
                      [multiple]="false"
                      [searchable]="true"
                      appendTo="body"
                      placeholder="Search vendor..."
                      [(ngModel)]="selectedVendorId">
                      <ng-template ng-option-tmp let-item="item">
                        <div>
                          <div style="font-weight: 500; font-size: 0.9rem;">{{ item.vendorName }}</div>
                          <div style="font-size: 0.78rem; color: #888;">{{ item.email }}</div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>

                <div class="section-footer no-border">
                  <button
                    type="button"
                    class="btn btn-outline-red"
                    [disabled]="actionLoading"
                    (click)="rejectOrder()">
                    Reject
                  </button>
                  <button
                    type="button"
                    class="btn btn-green"
                    [disabled]="actionLoading || !procHeadAmountInput || !selectedVendorId"
                    (click)="submitHeadApproval()">
                    {{ actionLoading ? 'Approving...' : '✓ Approve' }}
                  </button>
                </div>
              </ng-container>

              <!-- Already approved -->
              <ng-container *ngIf="order.status === 'HEAD_APPROVED'">
                <div class="info-banner" style="margin-top: 16px;">
                  ✓ You have approved this order with amount {{ formatCurrency(order.procHeadAmount) }}. Waiting for KAM confirmation.
                </div>
              </ng-container>

            </ng-container>

            <!-- ═══ ROLE_VENDOR VIEW ═══ -->
            <ng-container *ngIf="role === 'ROLE_VENDOR'">
              <div class="info-banner restricted-banner">
                <b>Vendor View.</b> Pricing details are not visible to your role.
              </div>
            </ng-container>

          </div>
        </div>

        <!-- Order Status Timeline -->
        <div class="card-section" *ngIf="order.orderStatus && order.orderStatus.length">
          <div class="section-header">
            <span class="step-badge">4</span>
            <h5>Order Status</h5>
          </div>
          <div class="section-body">
            <div class="status-timeline">
              <div class="status-item" *ngFor="let s of order.orderStatus">
                <div class="status-dot" [ngClass]="s.status === 'PENDING' ? 'dot-pending' : 'dot-done'"></div>
                <div class="status-info">
                  <span class="status-type">{{ s.statusType?.replace('_', ' ') | titlecase }}</span>
                  <span class="status-val" [ngClass]="s.status === 'PENDING' ? 'val-pending' : 'val-done'">{{ s.status }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Bottom bar -->
        <div class="bottom-bar">
          <button type="button" class="btn btn-outline" (click)="goBack()">Back</button>
          <span class="badge status-badge" [ngClass]="statusBadgeClass()">{{ statusLabel() }}</span>
        </div>

      </div>
    </div>
  </div>
</div>